import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CustomTable from '../../../Components/CustomTable/CustomTable';
import { useGetProductsListQuery } from '../../../Redux/ProductSlice';
import { useCategoriesListQuery } from '../../../Redux/category/categoryApi';
// selectedRows, checkboxNotRequired
const RelatedProductsModal = ({ handleShow, allListProducts, setAllListProducts, relatedListProducts, setRelatedListProducts, modalselectedRelatedIds, setModalSelectedRelatedIds }) => {




  const columns = [
    {
      Header: '#',
      CustomDesign: (cellProps) => {
        return (
          <>
            <input
              type='checkbox'
              className='productCheckBox form-check-input'
              checked={modalselectedRelatedIds?.includes(cellProps?.id)}
              onChange={(e) => {
                setModalSelectedRelatedIds((prev) =>
                  modalselectedRelatedIds?.includes(cellProps?.id)
                    ? prev?.filter((it) => it !== cellProps?.id)
                    : [...prev, cellProps?.id],
                );
              }}
            />
          </>
        );
      },
    },

    {
      Header: 'Product name',
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => (
        <>
          <div className='d-flex align-items-center'>
            <div className='flex-shrink-0 me-2'>
              <div className='avatar-sm bg-light rounded p-1 d-flex justify-content-center'>
                <img
                  src={
                    cellProps?.productListImageViews?.[0]?.productListImage?.url ||
                    cellProps?.ProductImageColourCombinations?.[0]?.image?.[0]?.preview
                  }
                  alt=''
                  className='img-fluid d-block avatar-xs mt-1'
                />
              </div>
            </div>
            <div className='flex-grow-1'>
              <h5 className='fs-14 mb-1'>
                <Link to={`/product-edit/${cellProps?.id}`} className='d-block text-reset'>
                  {' '}
                  {cellProps.productTitle}
                </Link>
              </h5>
              <p className='text-muted mb-0'>
                Category :{' '}
                <span className='fw-medium'>
                  {cellProps?.ProductCategoryCombinations?.reduce(
                    (elem, current) => `${elem + current?.Category?.name ?? ''},`,
                    '',
                  )}
                </span>
              </p>
            </div>
          </div>
        </>
      ),
    },
    {
      Header: 'Stock',

      fieldName: 'productTitle',
      CustomDesign: (cellProps) =>
        cellProps?.ProductSizeColourCombinations?.reduce(
          (acc, cur) => acc + Number(cur?.quantity),
          0,
        ),
    },
    {
      Header: 'Size',
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => {
        return (
          <div className='d-flex'>
            <div>
              {cellProps?.ProductSizeCombinations?.map((item, index) => (
                <span
                  className='badge py-2 px-2 bg-light rounded-circle text-info fs-13 fw-medium me-1'
                  style={{ width: '30px', height: '30px' }}
                >
                  {item?.Size?.name}
                </span>
              ))}
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Colour',
      fieldName: 'productTitle',
      CustomDesign: (cellProps) => {
        return (
          <>
            <div className='avatar-group'>
              {cellProps?.ProductColourCombinations?.map((color) => (
                <div
                  className='avatar-item'
                  style={{
                    backgroundColor: color?.ProductColour?.hexCode,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span className='avatar-text'></span>
                </div>
              ))}
            </div>
          </>
        );
      },
    },
    {
      Header: 'Price',

      fieldName: 'sellingPrice',
    },
  ];

  const [page, setPage] = useState(1);
  const [limit, setlimit] = useState(10);
  const [category, setcategory] = useState(null);
  let queryParams = [];

  if (page) {
    queryParams.push({ name: 'page', value: page });
  }
  if (limit) {
    queryParams.push({ name: 'limit', value: limit });
  }
  if (category) {
    queryParams.push({ name: 'categoryId', value: JSON.stringify([category]) });
  } else {
    queryParams = queryParams?.filter(it => it.name !== 'categoryId')

  }
  const {
    data: productList,
    isSuccess,
    error,
    isFetching: productListFetching,
  } = useGetProductsListQuery(queryParams);



  useEffect(() => {
    if (productList?.response?.length > 0) {
      const formattedProductList = {};
      productList?.response?.map(it => {
        formattedProductList[it?.id] = it
      })
      setAllListProducts((prev) => ({
        ...prev,
        ...formattedProductList,
      }));
    }
  }, [productList]);

  const { data: categoryListData } = useCategoriesListQuery();


  console.log('productList?.additional', productList?.additional)
  return (
    <React.Fragment>
      <Row className='g-4 mb-4'>
        <Col sm={9} className="col-lg-auto">
          <select className="form-select" data-choices data-choices-search-false name="choices-single-default" id="idStatus"
            onChange={e => {
              setPage(1);
              setcategory(e.target.value === 'Choose Category' ? null : e.target.value)
            }}
          >
            <option value={null} >Choose Category</option>
            {
              categoryListData?.response?.map(op => (

                <option value={op?.id}>{op?.name}</option>
              ))
            }

          </select>

        </Col>


      </Row>
      <div>
        <CustomTable
          limit={limit}
          setlimit={setlimit}
          key='Product List'
          metaData={productList?.additional}
          columns={columns}
          rowsData={productList?.response || []}
          page={page}
          setPage={setPage}
        />
        {/* <TableContainer
                    columns={columns}
                    data={(data || [])}
                    // data={(productList || [])}
                    // checkboxNotRequired={checkboxNotRequired}
                    // isGlobalFilter={true}
                    // selectedRows={data}
                    isAddUserList={false}
                    customPageSize={10}
                    // divClassName="table-responsive mb-1"
                    tableClass="gridjs-table"
                    theadClass="gridjs-th"
                    isProductsFilter={true}
                    SearchPlaceholder='Search Products...'
                /> */}
      </div>
    </React.Fragment>
  );
};

export default RelatedProductsModal;
